import React from 'react';
import { isSentryTestButtonEnabled } from 'utils/sentry';

const SentryTestCrashButton: React.FC = () => {
  if (!isSentryTestButtonEnabled()) {
    return null;
  }

  const handleTestCrash = () => {
    throw new Error('Sentry test crash (business portal)');
  };

  return (
    <div className="fixed right-4 bottom-4 z-[9999] flex flex-col gap-2">
      <button
        type="button"
        onClick={handleTestCrash}
        className="rounded border border-red-500 px-3 py-1.5 text-sm text-red-500 hover:bg-red-50"
      >
        Test Sentry crash
      </button>
    </div>
  );
};

export default SentryTestCrashButton;
